import type React from 'react';
import image from '../../assets/conversed-spinner.png';
import style from './LoadingSpinner.module.scss';

type TLoadingSpinnerProps = { visible: boolean };

export const LoadingSpinner: React.FC<TLoadingSpinnerProps> = ({ visible }) => {
  const { overlay, spinner } = style;

  if (!visible) return <></>;

  return (
    <div className={overlay}>
      <img alt='loading-spinner' className={spinner} src={image} />
    </div>
  );
};
